<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="active1 = 1"
            >{{ $t("m.options.listTab.model") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="active1 = 2"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="active1 = 3"
            >按用户</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button type="primary" icon="el-icon-delete" class="active-icon"
            >删除</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div
        class="box-content"
        style="max-height:calc(100% - 160px);"
        v-if="active1 == 1"
      >
        <div class="box-item box-sb box-active">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x.png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
      </div>
      <div
        class="box-content"
        style="max-height:calc(100% - 160px);"
        v-if="active1 == 2"
      >
        <div class="box-item box-sb box-active">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x.png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
      </div>
      <div
        class="box-content"
        style="max-height:calc(100% - 160px);"
        v-if="active1 == 3"
      >
        <div class="box-item box-sb box-active">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x.png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
        <div class="box-item box-sb">
          <div class="box-item-img">
            <img src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">D5号设备</div>
            <div class="sb-type">M2H</div>
          </div>
        </div>
      </div>
      <div class="sb-footer">
        <el-divider style="margin:0 0 15px 0;"></el-divider>
        <div class="sb-footer-line" style="margin-bottom:15px;">
          <el-button type="primary"
            ><span>豆温：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>热风温：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>排风温：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>环境温：</span><span class="value">160</span></el-button
          >
        </div>
        <div class="sb-footer-line">
          <el-button type="primary"
            ><span>火力：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>热风：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>滚筒：</span><span class="value">160</span></el-button
          >
          <el-button type="primary"
            ><span>冷却：</span><span class="value">160</span></el-button
          >
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">D5号设备</div>
        </div>
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text">序列号：</span>
          <span class="gray-text">8EDASIDADAD79798AS878SD78SD7A9</span>
        </div>
      </section>

      <section style="margin-top: 20px">
        <div class="row-box" style="background-color: #2D2F35FF">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">设备型号：</span>
                <span class="white-text">D5号设备</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">创建时间：</span>
                <span class="white-text">2020-06-01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙时长：</span>
                <span class="white-text">210小时</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">设备位置：</span>
                <span class="white-text">(工作位置)</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">运行时长：</span>
                <span class="white-text">510小时</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">设备状态：</span>
                <span class="white-text">(开/关)</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

      <section>
        <div class="box-header flex flex-center" style="margin-top: 30px">
          <div class="box-header-left flex flex-center">
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 1 }"
              @click="active2 = 1"
              >曲线列表</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 2 }"
              @click="active2 = 2"
              >运行日志</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 3 }"
              @click="active2 = 3"
              >维保提醒</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 4 }"
              @click="active2 = 4"
              >维保历史</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 5 }"
              @click="active2 = 5"
              >报警日志</span
            >
          </div>
        </div>
      </section>
      <!--曲线列表-->
      <section v-if="active2 == 1">
        <el-table :data="tableData1" border style="width: 100%">
          <el-table-column prop="name" :label="$t('m.table.name')">
          </el-table-column>
          <el-table-column
            prop="time"
            :label="$t('m.table.duration')"
            width="60"
          >
          </el-table-column>
          <el-table-column
            prop="date"
            :label="$t('m.table.date')"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="star"
            :label="$t('m.table.starLevel')"
            width="120"
          >
            <template slot-scope="scope">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="scope.row.star"
              ></el-rate>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('m.table.operation')"
            width="80"
          >
            <template>
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="dialogTableVisible2 = true"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          :total="200"
        >
        </el-pagination>
      </section>
      <!--运行日志-->
      <section v-if="active2 == 2">
        <el-table :data="tableData2" border style="width: 100%;">
          <el-table-column
            prop="time"
            :label="$t('m.table.duration')"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="date" label="上传时间" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          :total="200"
        >
        </el-pagination>
      </section>
      <!--维保提醒-->
      <section v-if="active2 == 3">
        <el-table :data="tableData3" border style="width: 100%;">
          <el-table-column prop="date" label="时间" width="150">
          </el-table-column>
          <el-table-column prop="condition" label="触发条件"> </el-table-column>
          <el-table-column prop="content" label="内容"> </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            align="left"
            >新增维保提醒</el-button
          >
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            :total="200"
          >
          </el-pagination>
        </div>
      </section>
      <!--维保历史-->
      <section v-if="active2 == 4">
        <el-table :data="tableData4" border style="width: 100%;">
          <el-table-column prop="date" label="时间" width="150">
          </el-table-column>
          <el-table-column prop="content" label="内容" align="center">
          </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            align="left"
            >新增维保历史</el-button
          >
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            :total="200"
          >
          </el-pagination>
        </div>
      </section>
      <!--报警日志-->
      <section v-if="active2 == 5">
        <el-table :data="tableData5" border style="width: 100%;">
          <el-table-column prop="id" label="编号" width="200">
          </el-table-column>
          <el-table-column
            prop="datetime"
            label="时间"
            align="center"
            width="250"
          >
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
          </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            align="left"
            >新增报警日志</el-button
          >
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            :total="200"
          >
          </el-pagination>
        </div>
      </section>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      title="搜索"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按序列号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按用户名</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按手机号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按地址</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="dialogTableVisible2"
    >
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">曲线详情</span>
        </div>
        <el-table :data="gridData2" border style="width:100%;">
          <el-table-column
            property="key1"
            :label="$t('m.table.name')"
          ></el-table-column>
          <el-table-column property="key2" label="类别"></el-table-column>
          <el-table-column property="key3" label="事件"></el-table-column>
          <el-table-column property="key4" label="时间"></el-table-column>
          <el-table-column property="key5" label="重量"></el-table-column>
        </el-table>
        <div class="table-totla-line">
          <span class="gray-text">总重量:</span>
          <span class="white-text">650kg</span>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">描述</span>
        </div>
        <div class="row-box">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">序列号：</span>
                <span class="white-text">23213123123</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">机器型号：</span>
                <span class="white-text">43242</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙时长：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展时间：</span>
                <span class="white-text">2021.06.01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展率：</span>
                <span class="white-text">15</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">入豆温：</span>
                <span class="white-text">生豆一</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温点：</span>
                <span class="white-text">导入</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">转黄点：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆：</span>
                <span class="white-text">340</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">二爆：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">结束：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温至黄点温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">黄点至一爆温升：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆至结束温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">过程</span>
        </div>
        <el-table :data="gridData1" border style="width:100%;">
          <el-table-column
            property="key1"
            width="60px"
            label="时间"
          ></el-table-column>
          <el-table-column
            property="key2"
            width="60px"
            label="豆温"
          ></el-table-column>
          <el-table-column
            property="key3"
            width="60px"
            label="ROR"
          ></el-table-column>
          <el-table-column
            property="key4"
            width="70px"
            label="热风温"
          ></el-table-column>
          <el-table-column
            property="key5"
            width="70px"
            label="出风温"
          ></el-table-column>
          <el-table-column
            property="key6"
            width="70px"
            label="环境温"
          ></el-table-column>
          <el-table-column
            property="key7"
            width="60px"
            label="火力"
          ></el-table-column>
          <el-table-column
            property="key8"
            width="60px"
            label="热风"
          ></el-table-column>
          <el-table-column
            property="key9"
            width="60px"
            label="滚筒"
          ></el-table-column>
          <el-table-column property="key10" label="标记"></el-table-column>
        </el-table>
      </section>
      <section>
        <div class="flex" style="justify-content:flex-end;margin-top:20px;">
          <div class="line-right">
            <el-button type="primary">导出PDF</el-button>
            <el-button type="primary">导出JSON</el-button>
          </div>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      active1: 1,
      active2: 1,
      name: "",
      date: "",
      selectValue: "",
      options: [
        {
          label: "等级一",
          value: "1",
        },
        {
          label: "等级二",
          value: "2",
        },
      ],
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      gridData1: [
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
      ],
      gridData2: [
        {
          key1: "卡图拉",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "新世界",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "斯考特实验室精选",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "法国传教士",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "铁皮卡",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
      ],
      tableData1: [
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016.05.03",
          star: 3,
        },
      ],
      tableData2: [
        {
          time: "65s",
          date: "2016.05.03",
        },
        {
          time: "5s",
          date: "2016.05.03",
        },
        {
          time: "5s",
          date: "2016.05.03",
        },
        {
          time: "5s",
          date: "2016.05.03",
        },
        {
          time: "5s",
          date: "2016.05.03",
        },
        {
          time: "5s",
          date: "2016.05.03",
        },
      ],
      tableData3: [
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
        {
          date: "2016.05.03",
          condition: "每运行200小时",
          content: "您的设备需要小保养，更换内部过滤层",
        },
      ],
      tableData4: [
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
        {
          date: "2016.05.03",
          content: "换内部过滤层",
        },
      ],
      tableData5: [
        {
          id: "202121021092",
          datetime: "2016.05.03 14:35",
          type: "无风压（可关）",
        },
        {
          id: "202121021092",
          datetime: "2016.05.03 14:35",
          type: "无风压（可关）",
        },
        {
          id: "202121021092",
          datetime: "2016.05.03 14:35",
          type: "无风压（可关）",
        },
        {
          id: "202121021092",
          datetime: "2016.05.03 14:35",
          type: "无风压（可关）",
        },
      ],
    };
  },
  methods: {
    handleChange() {},
  },
};
</script>
